module.exports = __webpack_public_path__ + "img/email_logo.3ee72014.svg";